import { render, staticRenderFns } from "./TaskPlate.vue?vue&type=template&id=3ee3e01a&scoped=true&"
import script from "./TaskPlate.vue?vue&type=script&setup=true&lang=js&"
export * from "./TaskPlate.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee3e01a",
  null
  
)

export default component.exports